import React from 'react';
import { Redirect } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';

import RegistryTable from '../shared/RegistryTable_RT.jsx';
import ConfirmActionModal from '../shared/ConfirmActionModal.jsx';
import SearchBlock from '../shared/SearchBlock';

import * as api from '../../api/api';
import * as utils from '../../utils';

class UserPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      selectedObjectId: 0,
      isUserAdmin: api.isUserAdmin(),
    };

    this.handleAddAction = this.handleAddAction.bind(this);
    this.handleEditAction = this.handleEditAction.bind(this);
    this.handleConfirmDeleteAction = this.handleConfirmDeleteAction.bind(this);

    this.handleRowClick = this.handleRowClick.bind(this);

    // this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
    // this.handleResetSearchClick = this.handleResetSearchClick.bind(this);

    this.tableColumns = [
      {
        Header: '_id',
        accessor: 'id',
      },
      {
        Header: '#',
        accessor: 'number',
      },
      {
        Header: 'ФИО',
        accessor: 'fio',
      },
      {
        Header: 'E-mail',
        accessor: 'email',
      },
      {
        Header: 'Логин',
        accessor: 'login',
      },
      {
        Header: 'Роль',
        accessor: 'role',
      },
    ];
  }

  componentDidMount() {
    if (!api.isUserAdmin()) {
      this.setState({
        redirectUrl: '/users/permission-denied',
        needRedirect: true,
      });

      return;
    }

    this.fillReestr();
  }

  fillReestr() {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(api.getUsers()).then(
      (response) => {
        this.setState({
          data: response.data.data.map((item, i) => {
            return {
              id: item.id,
              number: i + 1,
              fio: item.fio,
              email: item.email,
              login: item.login,
              role: item.role,
            };
          }),
        });

        this.props.updateLoader({
          loaded: true,
          message: '',
        });
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при получении данных: ' + error,
        });
      },
    );
  }

  handleRowClick(displayId) {
    this.setState({
      selectedObjectId: displayId,
      markersUpdateInd: displayId,
    });
  }

  handleAddAction() {
    this.setState({
      redirectUrl: '/users/0/details?return_url=/users',
    });
  }

  handleEditAction() {
    this.setState({
      redirectUrl:
        '/users/' + this.state.selectedObjectId + '/details?return_url=/users',
    });
  }

  handleConfirmDeleteAction() {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(api.removeUser(this.state.selectedObjectId)).then(
      (response) => {
        this.fillReestr();
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при выполнении действия: ' + error,
        });
      },
    );
  }

  // handleSearchButtonClick(searchValue) {
  //     this.processGetDisplaysPromise(api.searchDisplays(searchValue));
  // }

  // handleResetSearchClick() {
  //     this.processGetDisplaysPromise(api.getDisplays());
  // }

  render() {
    if (this.state.redirectUrl) {
      return <Redirect to={this.state.redirectUrl} />;
    }

    return (
      <div className="d-flex justify-content-between">
        <div className="flex-grow-1">
          {/* <SearchBlock
                        placeholder="Введите часть названия или описания..."
                        handleSearchButtonClick={this.handleSearchButtonClick}
                        onResetSearchClick={this.handleResetSearchClick}
                    /> */}
          <div className="mt-4">
            <RegistryTable
              columns={this.tableColumns}
              data={this.state.data}
              showActions={true}
              onRowClick={this.handleRowClick}
              onAddAction={this.handleAddAction}
              onEditAction={this.handleEditAction}
            />
          </div>
        </div>

        <ConfirmActionModal onConfirm={this.handleConfirmDeleteAction} />
      </div>
    );
  }
}

export default UserPage;
